module.exports = __webpack_public_path__ + "static/media/twa_sat.18b904f3.webp";